import { createAsyncThunk } from "@reduxjs/toolkit"

import { UserMode, UserModeAPI } from "@type/api/user-mode.d"

export const updateUserMode = createAsyncThunk<UserModeAPI, UserMode>("userMode/updateUserMode", async (mode) => ({
    mode
}))
